module.exports = __webpack_public_path__ + "static/media/rumi-product-img@2x.41b5942d.png";